import { marketServiceInstance } from './market.service.instance';
import type {
  MarketAccountResponse,
  MarketAccountUpdateResponse,
  UpdateMarketAccountPayload,
} from './interfaces/account.types';
import {
  MarketAccountUpdateResponseSchema,
  normalizeMarketAccountResponse,
} from './interfaces/account.types';

export const getMarketAccount = async (): Promise<MarketAccountResponse> => {
  const response = await marketServiceInstance.get<MarketAccountResponse>('/account');
  return normalizeMarketAccountResponse(response.data);
};

export const patchMarketAccount = async (
  payload: UpdateMarketAccountPayload
): Promise<MarketAccountUpdateResponse> => {
  const response = await marketServiceInstance.patch<MarketAccountUpdateResponse>(
    '/account',
    payload
  );
  const parsed = MarketAccountUpdateResponseSchema.safeParse(response.data);
  return parsed.success ? parsed.data : {};
};
